/**
 * Class that represent a TreatmentChain with only usefull params
 */
export class TreatmentChain {

  /**
   * The treatment chain Name
   */
  public sTrtChainName: string;

  /**
   * instantiate class variables
   *
   * @param {string} sTrtChainName - the treatment Chain name
   */
  constructor(sTrtChainName: string) {
    this.sTrtChainName = sTrtChainName;
  }
}
